import { g as n } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const f = {
  name: "DtIconLink2Off",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], p = ["clip-path"], h = ["id"];
function m(e, t, r, _, g, i) {
  return d(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--link-2-off"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Link 2 Off",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      fill: "currentColor"
    }, [...t[0] || (t[0] = [
      a("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7 3.5a.5.5 0 0 1 .5-.5h1a3 3 0 0 1 2.4 4.8.5.5 0 1 1-.8-.6A2 2 0 0 0 8.5 4h-1a.5.5 0 0 1-.5-.5Z"
      }, null, -1),
      a("path", { d: "M2.086 4.586A2 2 0 0 0 3.5 8h1a.5.5 0 1 1 0 1h-1a3 3 0 0 1-1.026-5.819L.647 1.354a.5.5 0 1 1 .707-.708l10 10a.5.5 0 0 1-.707.708L5.793 6.5H4a.5.5 0 0 1 0-1h.793l-1.49-1.49a2 2 0 0 0-1.217.576Z" }, null, -1)
    ])], 8, p),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, h)
    ])
  ], 10, c);
}
const L = /* @__PURE__ */ u(f, [["render", m]]);
export {
  L as default
};
//# sourceMappingURL=link-2-off.js.map
